<template>
  <div class="item">
    <img class="qs-icon" :src="item.qslogo" alt="">
    <div class="qs-info-box">
      <span class="qs-name text-primary">{{ item.qsname }}</span>
      <span class="qs-account text-sub">资金账号：****{{item.account.slice(item.account.length - 4)}}</span>
    </div>
    <div @click="handleClick" class="btn">立即申购</div>
  </div>
</template>

<script>
export default {
  name: "BrokerItem",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClick () {
      this.$emit("click");
    }
  }
};
</script>

<style scoped lang="less">
@import "../style/mixins";
.item {
  box-sizing: border-box;
  height: 1.5rem;
  .theme-mixins(background, rgba(246, 246, 246, 0.60), rgba(37,37,37,0.60));
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.32rem;

  .qs-icon {
    width: 0.8rem;
    height: 0.8rem;
  }

  .qs-info-box {
    display: flex;
    flex-direction: column;
    margin-left: 0.16rem;
    .qs-name {
      font-family: PingFangSC-Medium;
      font-size: 0.32rem;
      letter-spacing: 0;
      font-weight: 500;
    }

    .qs-account {
      font-family: PingFangSC-Regular;
      font-size: 0.24rem;
      letter-spacing: 0;
      font-weight: 400;
      margin-top: 0.08rem;
    }
  }

  .btn {
    margin-left: auto;
    width: 1.62rem;
    height: 0.64rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .theme-mixins(background, #FA3B32, #E93030);
    border-radius: 0.12rem;
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    color: #FFFFFF;
    font-weight: 400;
  }
}
</style>
